// mixin wykorzystywany w widoku oferty, działki, projektu
export default {
  computed: {
    entityID() {
      return this.$route.params.id;
    },
    isNewEntity() {
      return isNaN(this.entityID);
    }
  },
  watch: {
    entityID() {
      this.init();
    }
  }
};
